import { pushToNonCriticalQueue } from './idleQueue';

const delayedScheduler = (callback: any, timeout?: number) => {
  // Check if requestIdleCallback is supported
  if (
    typeof window !== 'undefined' &&
    typeof window.requestIdleCallback === 'function'
  ) {
    // Use requestIdleCallback if available
    // if (timeout) {
    //   window.requestIdleCallback(callback, { timeout });
    // } else {
    //   window.requestIdleCallback(callback);
    // }
    pushToNonCriticalQueue(callback);
  } else {
    // Fallback to setTimeout if requestIdleCallback is not available
    if (timeout) {
      setTimeout(callback, timeout);
    } else {
      setTimeout(callback);
    }
  }
};

export const yeildToMainThread = callback => {
  // setTimeout(callback,0)
  return new Promise(() => {
    setTimeout(callback, 0);
  });
};

export default delayedScheduler;
